import React, { useEffect, useState } from 'react';
import { LabeledInput, SelectInput } from '../../Components';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import InfoIcon from '@material-ui/icons/Info';
import './index.css';
import { PopupModal } from '../../Modals/Index';
const Shipping = ({ next, prev }) => {
    ////////////////
    //Pincode Modal Control
    const [pinModal, setPinModal] = useState(true);
    ////////////////

    const [refNo, setRefNo] = useState('');
    const [invoiceNo, setInvoice] = useState('');
    const [name, setname] = useState('');
    const [add1, setadd1] = useState('');
    const [add2, setadd2] = useState('');
    const [add3, setadd3] = useState('');
    // const [country, setCountry] = useState('Ind');
    const [city, setCity] = useState('');
    const [pin, setPin] = useState('');
    const [state, setState] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');

    useEffect(() => {
        setState('Gujrat');
    }, [pin]);

    return (
        <>
            {/* <PopupModal setStateFalse={() => {}} state={pinModal}>
                <div style={{ width: 'max-content' }} className="popupConatiner">
                    <div className="home_head">
                        <h2 className="home_heading">Enter Pincode To Proceed</h2>
                    </div>
                    <div className="popup_body">
                        <div className="select_container">
                            <LabeledInput
                                name="Pincode"
                                info={true}
                                value={pin}
                                changeHandler={(e) => {
                                    setPin(e.target.value);
                                }}
                                label={'Pincode'}
                            />
                        </div>
                        <div className="footer_button">
                            <button
                                onClick={() => {
                                    if (pin > 3) {
                                        setState('Gujrat');
                                        setPinModal((prev) => !prev);
                                    }
                                }}
                                className="btn-orange "
                            >
                                <p>Proceed</p>
                            </button>
                        </div>
                    </div>
                </div>
            </PopupModal> */}
            <div className="shipping">
                <h2 className="home_heading">Order Details</h2>
                <div className="shipping_invoice">
                    <LabeledInput
                        light={true}
                        name="order number"
                        info={true}
                        value={refNo}
                        changeHandler={(e) => {
                            setRefNo(e.target.value);
                        }}
                        label={'Order Number'}
                    />
                    <LabeledInput
                        light={true}
                        name="invoice value"
                        info={true}
                        value={invoiceNo}
                        changeHandler={(e) => {
                            setInvoice(e.target.value);
                        }}
                        label={'Invoice Value'}
                    />
                </div>
                <h2 className="home_heading">Shipping Details</h2>
                <div className="shipping_detailss">
                    <div className="shipping_details_name">
                        <LabeledInput
                            light={true}
                            name="customer name"
                            value={name}
                            changeHandler={(e) => {
                                setname(e.target.value);
                            }}
                            label={'Customer Name'}
                        />
                    </div>

                    <div className="shipping_details_address">
                        {/* <div className="select_input_spda">
                        <p className="inpt_label">{'Country'}</p>
                        <SelectInput
                            value={country}
                            changeHandler={(e) => {
                                setCountry(e.target.value);
                            }}
                            options={[
                                { name: 'India', value: 'Ind' },
                                { name: 'United State', value: 'US' },
                                { name: 'United Kingdom', value: 'UK' },
                            ]}
                        />
                    </div> */}
                        <LabeledInput
                            light={true}
                            name="zipcode"
                            value={pin}
                            changeHandler={(e) => {
                                setPin(e.target.value);
                            }}
                            label={'Pincode'}
                        />
                        <LabeledInput
                            light={true}
                            name="city"
                            value={city}
                            changeHandler={(e) => {
                                setCity(e.target.value);
                            }}
                            label={'City'}
                        />
                        <LabeledInput
                            light={true}
                            name="state"
                            value={state}
                            disbale={true}
                            changeHandler={(e) => {
                                setState(e.target.value);
                            }}
                            label={'State'}
                        />
                    </div>
                    <div className="shipping_details_address">
                        <LabeledInput
                            light={true}
                            name="Line 1"
                            value={add1}
                            changeHandler={(e) => {
                                setadd1(e.target.value);
                            }}
                            label={'Address Line 1'}
                        />
                        <LabeledInput
                            light={true}
                            name=" Line 2"
                            value={add2}
                            changeHandler={(e) => {
                                setadd2(e.target.value);
                            }}
                            label={'Address Line 2'}
                        />
                        <LabeledInput
                            light={true}
                            name="Line 3"
                            value={add3}
                            changeHandler={(e) => {
                                setadd3(e.target.value);
                            }}
                            label={'Address Line 3'}
                        />
                    </div>
                    <div className="shipping_details_address" style={{ justifyContent: 'flex-start' }}>
                        <LabeledInput
                            light={true}
                            name="phone"
                            value={phone}
                            changeHandler={(e) => {
                                setPhone(e.target.value);
                            }}
                            label={'Phone Number'}
                            style={{ marginRight: '2rem' }}
                        />
                        <LabeledInput
                            light={true}
                            name="email"
                            value={email}
                            changeHandler={(e) => {
                                setEmail(e.target.value);
                            }}
                            label={'Email'}
                        />
                    </div>
                </div>
                <div className="confirm_product_footer">
                    <div className="confirm_product_footer_left">
                        {/* <p>Collect cash on delivery for this order</p>
                        <InfoIcon className="small-gray-i" /> */}
                    </div>
                    <div className="confirm_product_footer_right">
                        <button onClick={prev} style={{ marginRight: '2rem' }} className="btn-gray">
                            <KeyboardBackspaceIcon className="btn-icon " />
                            <p>Back</p>
                        </button>
                        <button onClick={next} className="btn-orange ">
                            <p>Next</p>
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Shipping;
